class WIquickAdd extends HTMLElement{
    constructor(){
        super();
    }
    connectedCallback() {
        this.clickOnSingleVariant();
    }
    clickOnSingleVariant() {
        let varBtn = this.querySelectorAll('.WI_quickAdd_atc');
        varBtn.forEach(variant => {
            variant.addEventListener('click', async (e)=>{
                e.preventDefault();
                let loadingCartBlock = document.querySelector('.WI_loadingCartItemBlock');
                let emptyCart =  document.querySelector('.WI_cartDrawerin_cart_empty');
                if (loadingCartBlock != null) {
                    loadingCartBlock.style.display = "block";
                }
                if (emptyCart != null) {
                    emptyCart.style.display = "none";
                }
                const openCart = new CustomEvent("opencart", { bubbles: true });
                document.dispatchEvent(openCart);
                let variantId = variant.getAttribute('data-variantid');
                let formData = {
                    'items': [{
                        "id": variantId,
                        "quantity": 1
                    }]
                };
                await fetch('/cart/add',{
                    method: 'post',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(formData)
                });   
                const updateCart = new CustomEvent("updateCart", { bubbles: true });
                document.dispatchEvent(updateCart);
            });
        });
    };
}

customElements.define("wi-quickadd", WIquickAdd);